import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const articleScroll = {
  fetchArticleScroll: lazyModuleMethod(
    () => import('./fetchArticleScroll'),
    'default'
  ),
}
